import { render, staticRenderFns } from "./home-ningbo.vue?vue&type=template&id=057ec0dd&scoped=true&"
import script from "./home-ningbo.vue?vue&type=script&lang=ts&"
export * from "./home-ningbo.vue?vue&type=script&lang=ts&"
import style0 from "./home-ningbo.vue?vue&type=style&index=0&id=057ec0dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ec0dd",
  null
  
)

export default component.exports